import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.7703 41.1669C73.7703 41.1669 60.2103 34.2768 56.1603 29.5468C51.6603 24.2868 51.8604 1.64685 51.8604 1.64685H39.4403C39.4403 1.64685 39.7503 24.3968 35.1403 29.5468C30.2503 35.0068 17.5303 40.9669 17.5303 40.9669C23.7203 55.5469 36.1203 59.2669 45.6503 59.2669C55.1803 59.2669 67.5803 55.7468 73.7703 41.1669Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.3 58.0668C85.57 46.0768 82.09 42.8168 77.42 40.4668C74.91 39.1968 60.3301 31.6268 60.3301 31.6268L54.9801 25.6068L45.65 30.4668L36.3201 25.6068L30.9701 31.6268C30.9701 31.6268 16.39 39.1968 13.88 40.4668C9.21 42.8168 5.65 46.4468 4 58.0668C2.3 69.9868 2.08008 71.8868 2.08008 71.8868H89.2301C89.2201 71.8768 89.07 70.3168 87.3 58.0668Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M30.9697 31.6269L40.5497 40.7969L45.5897 30.1569" stroke={outline} strokeMiterlimit="10" fill={fill} />
      <path d="M60.3298 31.6269L50.0798 40.5769L45.5898 30.1569" stroke={outline} strokeMiterlimit="10" fill={fill} />
      <path d="M44.3203 32.5768V71.8768" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M46.7002 32.5768V71.8768" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path
        d="M56.5002 28.4069L45.7603 32.8869L35.0303 28.4069L35.2703 41.4969L45.7603 35.5269L56.2603 41.4969L56.5002 28.4069Z"
        fill={secondaryFill}
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.6477"
          y1="43.6068"
          x2="45.6477"
          y2="4.74325"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
